import styled from 'styled-components';
import { Media } from 'assets/Mixins.style';

export const Wrapper = styled.div`
  display: block;
  height: 100%;
  width: ${props => `${props.width}px`};

  ${Media.xxlg`
    width: ${props => `${props.width * 0.5}px`};
  `}

  ${Media.lg`
    width: ${props => `${props.width * 0.3}px`};
  `}
`;

export const Spacer = styled.div`
  height: 100%;
  width: 2px;
  margin: 0 auto;
  background: ${props => props.color || props.theme.background};
`;
